// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/State_01.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/vector-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/images/calendar.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/images/user-scan.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/images/reports.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/images/trophy.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scratch {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  width: 100%;
}
.scratch--container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1480px;
  gap: 56px;
  width: 100%;
  z-index: 1;
}

div.scratch > div > div.comp-title > h2{
  color: #3B3B3B;
}

div.scratch > div > div.comp-title > p{
  width: 100%
}
/* Container integrado */
.integrated-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  margin: 0 auto;
  padding: 0px;
  position: relative;
  margin-top:15px;
}

/* ===== ESTILOS DO SCRATCHCARD ===== */
.scratchcard-section {
  position: relative;
  z-index: 10; /* Garante que o scratchcard fique sobre o calendário */
  margin-right: -20px; /* Sobreposição com o calendário */
}

.scratchcard-container {
  width: 100%;
  max-width: 320px;
  margin: 0 auto;
  padding: 0px;
  transform: rotate(-6deg);
}

.scratchcard {
  position: relative;
  width: 320px;
  height: 320px;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

/* Conteúdo inicial com o texto */
.scratch-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 20;
  display: block;
  transition: transform 0.5s ease-in-out;
}

.scratch-content.hidden {
  transform: translateY(-100%);
  visibility: hidden;
}

/* Conteúdo do resultado */
.scratchcard-result {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scratchcard.revealed .scratchcard-result {
  z-index: 25;
}

/* Estilos para o conteúdo do resultado */
.main-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 18px;
  position: relative;
  margin: 0 auto;
  padding: 36px 43px;
  background: var(--color-primary-light-yellow);
  border-radius: 20px;
}

.raspaveis-date {
  position: relative;
}

.disponibilidade-info {
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
  min-width: 0;
  font-family: ShellBook, var(--default-font-family);
  font-size: 18px;
  font-weight: 400;
  line-height: 28.8px;
  text-align: left;
  z-index: 1;
}

.disponibilidade-data {
  position: relative;
  color: var(--color-contrast-dark-red);
  font-family: ShellHeavy, var(--default-font-family);
  font-size: 18px;
  font-weight: 600;
  line-height: 28.8px;
  text-align: left;
}

.liberacao-info {
  position: relative;
  color: var(--color-contrast-dark-gray);
  font-family: ShellBook, var(--default-font-family);
  font-size: 18px;
  font-weight: 400;
  line-height: 28.8px;
  text-align: left;
}

/* Fundo do card */
.rectangle {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  margin: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: cover;
  z-index: 15;
  border-radius: 20px;
}

/* Texto principal */
.ready-to-scratch {
  position: absolute;
  width: 202px;
  height: auto;
  top: 76px;
  left: 51px;
  color: var(--color-primary-white);
  font-family: ShellMedium, var(--default-font-family);
  font-size: 24px;
  font-weight: 500;
  line-height: 31.2px;
  text-align: left;
  z-index: 25;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
}

/* Texto "Raspe aqui" */
.scratch-here {
  position: absolute;
  height: auto;
  top: 69.38%;
  left: 15.92%;
  color: #ffffff;
  font-family: ShellBook, var(--default-font-family);
  font-size: 18px;
  font-weight: 400;
  line-height: 28.8px;
  text-align: left;
  white-space: nowrap;
  z-index: 25;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
}

/* Ícone de seta */
.vector {
  position: absolute;
  width: 5.87%;
  height: 5.82%;
  top: 70.63%;
  left: 45.31%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
  background-size: 100% 100%;
  z-index: 25;
  filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.5));
}

/* Overlay para a animação */
.scratch-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 5;
  pointer-events: none;
}

/* Container para os frames de animação */
.scratch-animation-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  pointer-events: none;
}

/* Frames individuais da animação */
.scratch-frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
  object-fit: cover;
  border-radius: 20px;
}

.scratch-frame.active {
  display: block;
}

.scratchcard.scratching .scratch-frame.active {
  display: block;
}

.scratchcard.revealed .scratch-animation-container {
  display: none;
}

/* ===== ESTILOS DO CALENDÁRIO ===== */
.calendar-section {
  min-width: 300px;
}

.calendar {
  width: 100%;
  max-width: 1000px;
  position: relative;
}

.calendar-container {
  background-color: #fff;
  overflow: hidden;
  padding: 20px 60px 20px 24px;
  position: relative;
}

/* Navegação do calendário */
.calendar-navigation {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  display: block; /* Garante que as setas estejam visíveis em desktop */
}

.nav-buttons-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.nav-button-item {
  background: var(--color-primary-white);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  padding: 0;
  opacity: 0;
  visibility: hidden;
  transform: scale(0.8);
  position: relative;
}

.nav-button-item.visible {
  opacity: 1;
  visibility: visible;
  transform: scale(1);
}

/* Quando apenas o botão next está visível, ele fica no topo */
.nav-button-item.next.visible:only-child,
.nav-button-item.prev.visible:only-child {
  top: -50px;
  transition: top 0.3s, opacity 0.3s, visibility 0.3s, transform 0.3s;
}

/* Quando ambos os botões estão visíveis, eles voltam à posição original */
.nav-button-item.visible:not(:only-child) {
  top: 0;
  transition: top 0.3s, opacity 0.3s, visibility 0.3s, transform 0.3s;
}

.nav-button-item img {
  width: 100%;
  height: 100%;
}

.nav-button-item:hover {
  opacity: 0.8;
}

/* Container do viewport do slider */
.calendar-viewport {
  width: calc(280px * 3 + 45px * 2); /* Exatamente 3 cards (280px cada) + 2 espaços entre eles (32px cada) */
  overflow: hidden;
  position: relative;
  margin: 0 auto; /* Centraliza o viewport */
  padding-left: 8px;
}

/* Slider do calendário */
.calendar-slider {
  display: flex;
  transition: transform 0.3s ease-in-out;
  gap: 32px;
  width: max-content;
  padding: 20px 0;
}

/* Removido .calendar-slide e .calendar-row que não são mais necessários */

/* Cards de sorteio */
.raffle-card {
  background-color: var(--color-primary-light-gray);
  border: 1px solid var(--color-primary-offwhite);
  border-radius: 24px;
  padding: 36px;
  width: 280px;
  min-height: 300px;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 24px;
  transition: box-shadow 0.3s;
}

.raffle-card:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.raffle-title {
  color: var(--color-primary-red);
}

.raffle-details {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.raffle-item {
  display: flex;
  align-items: flex-start;
  color: #3B3B3B;
}

.raffle-item:last-child {
  margin-bottom: 0;
}

.icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  flex-shrink: 0;
}

.icon-calendar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.icon-extraction {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.icon-verification {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.icon-winners {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.item-info {
  display: flex;
  flex-direction: column;
}

.label {
  font-family: var(--font-headline-1);
  font-weight: 600;
  font-size: 12px;
  color: var(--shell-light-text);
  margin-bottom: 2px;
}

.value {
  font-family: var(--font-headline-2);
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
}

/* Paginação para dispositivos móveis */
.calendar-pagination {
  display: none; /* Oculto por padrão em desktop */
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
  position: relative;
  z-index: 20;
}

.pagination-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--color-contrast-gray);
  border: none;
  cursor: pointer;
  transition: width ease-in 0.3s, height ease-in 0.3s, background-color ease-in 0.3s;
}

.pagination-dot.active {
  width: 8px;
  height: 8px;
  background-color: var(--color-primary-red);
}

/* Responsividade */
@media (max-width: 1230px) {
  /* Ajuste para telas menores que 1230px */
  .calendar-viewport {
    width: calc(280px * 3 + 20px * 2); /* Mantém a largura para 3 cards */
  }
}

@media (max-width: 768px) {
  .integrated-container {
    flex-direction: column;
    align-items: center;
  }
  
  .scratchcard-section {
    margin-right: 0;
    margin-bottom: 30px;
  }

  .calendar-container {
    width: fit-content;
    padding: 20px 24px;
    margin: 0 auto;
  }

  .calendar-slider {
    padding: 0;
  }
  
  .calendar-section {
    padding-left: 0;
    width: 100%;
  }

  .calendar-navigation {
    width: 100%;
    transform: translateY(-10px);
  }

  .calendar-navigation .nav-button-item {
    position: absolute;
  }

  .calendar-navigation .prev {
    left: 0;
  }

  .calendar-navigation .next {
    right: 0;
  }
  
  /* Mostra a paginação em dispositivos móveis */
  .calendar-pagination {
    display: flex;
  }
  
  /* Ajusta o viewport para mostrar apenas 1 card por vez em dispositivos móveis */
  .calendar-viewport {
    width: 300px;
  }
  
  .raffle-card {
    width: 280px;
  }
}`, "",{"version":3,"sources":["webpack://./src/scripts/components/scratch/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;AACF;AACA,wBAAwB;AACxB;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,WAAW,EAAE,uDAAuD;EACpE,mBAAmB,EAAE,kCAAkC;AACzD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,+CAA+C;AACjD;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,SAAS;EACT,oEAA6D;EAC7D,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,oDAAoD;EACpD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,2CAA2C;AAC7C;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,2CAA2C;AAC7C;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,oEAAiE;EACjE,0BAA0B;EAC1B,WAAW;EACX,mDAAmD;AACrD;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,UAAU;EACV,oBAAoB;AACtB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,cAAc,EAAE,qDAAqD;AACvE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;;EAEE,UAAU;EACV,mEAAmE;AACrE;;AAEA,0EAA0E;AAC1E;EACE,MAAM;EACN,mEAAmE;AACrE;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,iCAAiC,EAAE,uEAAuE;EAC1G,gBAAgB;EAChB,kBAAkB;EAClB,cAAc,EAAE,0BAA0B;EAC1C,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA,0EAA0E;;AAE1E,qBAAqB;AACrB;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,yDAAoD;AACtD;;AAEA;EACE,yDAAqD;AACvD;;AAEA;EACE,yDAAmD;AACrD;;AAEA;EACE,yDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,aAAa,EAAE,iCAAiC;EAChD,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4CAA4C;EAC5C,YAAY;EACZ,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;EACE,yCAAyC;EACzC;IACE,iCAAiC,EAAE,kCAAkC;EACvE;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;IACX,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,QAAQ;EACV;;EAEA,8CAA8C;EAC9C;IACE,aAAa;EACf;;EAEA,gFAAgF;EAChF;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".scratch {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: flex-start;\n  width: 100%;\n}\n.scratch--container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  max-width: 1480px;\n  gap: 56px;\n  width: 100%;\n  z-index: 1;\n}\n\ndiv.scratch > div > div.comp-title > h2{\n  color: #3B3B3B;\n}\n\ndiv.scratch > div > div.comp-title > p{\n  width: 100%\n}\n/* Container integrado */\n.integrated-container {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: flex-start;\n  margin: 0 auto;\n  padding: 0px;\n  position: relative;\n  margin-top:15px;\n}\n\n/* ===== ESTILOS DO SCRATCHCARD ===== */\n.scratchcard-section {\n  position: relative;\n  z-index: 10; /* Garante que o scratchcard fique sobre o calendário */\n  margin-right: -20px; /* Sobreposição com o calendário */\n}\n\n.scratchcard-container {\n  width: 100%;\n  max-width: 320px;\n  margin: 0 auto;\n  padding: 0px;\n  transform: rotate(-6deg);\n}\n\n.scratchcard {\n  position: relative;\n  width: 320px;\n  height: 320px;\n  border-radius: 20px;\n  overflow: hidden;\n  cursor: pointer;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n}\n\n/* Conteúdo inicial com o texto */\n.scratch-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 20;\n  display: block;\n  transition: transform 0.5s ease-in-out;\n}\n\n.scratch-content.hidden {\n  transform: translateY(-100%);\n  visibility: hidden;\n}\n\n/* Conteúdo do resultado */\n.scratchcard-result {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.scratchcard.revealed .scratchcard-result {\n  z-index: 25;\n}\n\n/* Estilos para o conteúdo do resultado */\n.main-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  flex-wrap: nowrap;\n  gap: 18px;\n  position: relative;\n  margin: 0 auto;\n  padding: 36px 43px;\n  background: var(--color-primary-light-yellow);\n  border-radius: 20px;\n}\n\n.raspaveis-date {\n  position: relative;\n}\n\n.disponibilidade-info {\n  align-self: stretch;\n  flex-shrink: 0;\n  position: relative;\n  min-width: 0;\n  font-family: ShellBook, var(--default-font-family);\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 28.8px;\n  text-align: left;\n  z-index: 1;\n}\n\n.disponibilidade-data {\n  position: relative;\n  color: var(--color-contrast-dark-red);\n  font-family: ShellHeavy, var(--default-font-family);\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28.8px;\n  text-align: left;\n}\n\n.liberacao-info {\n  position: relative;\n  color: var(--color-contrast-dark-gray);\n  font-family: ShellBook, var(--default-font-family);\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 28.8px;\n  text-align: left;\n}\n\n/* Fundo do card */\n.rectangle {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  margin: 0;\n  background: url(/public/images/State_01.png) no-repeat center;\n  background-size: cover;\n  z-index: 15;\n  border-radius: 20px;\n}\n\n/* Texto principal */\n.ready-to-scratch {\n  position: absolute;\n  width: 202px;\n  height: auto;\n  top: 76px;\n  left: 51px;\n  color: var(--color-primary-white);\n  font-family: ShellMedium, var(--default-font-family);\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 31.2px;\n  text-align: left;\n  z-index: 25;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);\n}\n\n/* Texto \"Raspe aqui\" */\n.scratch-here {\n  position: absolute;\n  height: auto;\n  top: 69.38%;\n  left: 15.92%;\n  color: #ffffff;\n  font-family: ShellBook, var(--default-font-family);\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 28.8px;\n  text-align: left;\n  white-space: nowrap;\n  z-index: 25;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);\n}\n\n/* Ícone de seta */\n.vector {\n  position: absolute;\n  width: 5.87%;\n  height: 5.82%;\n  top: 70.63%;\n  left: 45.31%;\n  background: url(/public/images/vector-arrow.svg) no-repeat center;\n  background-size: 100% 100%;\n  z-index: 25;\n  filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.5));\n}\n\n/* Overlay para a animação */\n.scratch-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  z-index: 5;\n  pointer-events: none;\n}\n\n/* Container para os frames de animação */\n.scratch-animation-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n  pointer-events: none;\n}\n\n/* Frames individuais da animação */\n.scratch-frame {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  object-fit: cover;\n  border-radius: 20px;\n}\n\n.scratch-frame.active {\n  display: block;\n}\n\n.scratchcard.scratching .scratch-frame.active {\n  display: block;\n}\n\n.scratchcard.revealed .scratch-animation-container {\n  display: none;\n}\n\n/* ===== ESTILOS DO CALENDÁRIO ===== */\n.calendar-section {\n  min-width: 300px;\n}\n\n.calendar {\n  width: 100%;\n  max-width: 1000px;\n  position: relative;\n}\n\n.calendar-container {\n  background-color: #fff;\n  overflow: hidden;\n  padding: 20px 60px 20px 24px;\n  position: relative;\n}\n\n/* Navegação do calendário */\n.calendar-navigation {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 10;\n  display: block; /* Garante que as setas estejam visíveis em desktop */\n}\n\n.nav-buttons-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.nav-button-item {\n  background: var(--color-primary-white);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s;\n  padding: 0;\n  opacity: 0;\n  visibility: hidden;\n  transform: scale(0.8);\n  position: relative;\n}\n\n.nav-button-item.visible {\n  opacity: 1;\n  visibility: visible;\n  transform: scale(1);\n}\n\n/* Quando apenas o botão next está visível, ele fica no topo */\n.nav-button-item.next.visible:only-child,\n.nav-button-item.prev.visible:only-child {\n  top: -50px;\n  transition: top 0.3s, opacity 0.3s, visibility 0.3s, transform 0.3s;\n}\n\n/* Quando ambos os botões estão visíveis, eles voltam à posição original */\n.nav-button-item.visible:not(:only-child) {\n  top: 0;\n  transition: top 0.3s, opacity 0.3s, visibility 0.3s, transform 0.3s;\n}\n\n.nav-button-item img {\n  width: 100%;\n  height: 100%;\n}\n\n.nav-button-item:hover {\n  opacity: 0.8;\n}\n\n/* Container do viewport do slider */\n.calendar-viewport {\n  width: calc(280px * 3 + 45px * 2); /* Exatamente 3 cards (280px cada) + 2 espaços entre eles (32px cada) */\n  overflow: hidden;\n  position: relative;\n  margin: 0 auto; /* Centraliza o viewport */\n  padding-left: 8px;\n}\n\n/* Slider do calendário */\n.calendar-slider {\n  display: flex;\n  transition: transform 0.3s ease-in-out;\n  gap: 32px;\n  width: max-content;\n  padding: 20px 0;\n}\n\n/* Removido .calendar-slide e .calendar-row que não são mais necessários */\n\n/* Cards de sorteio */\n.raffle-card {\n  background-color: var(--color-primary-light-gray);\n  border: 1px solid var(--color-primary-offwhite);\n  border-radius: 24px;\n  padding: 36px;\n  width: 280px;\n  min-height: 300px;\n  flex-shrink: 0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  transition: box-shadow 0.3s;\n}\n\n.raffle-card:hover {\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n}\n\n.raffle-title {\n  color: var(--color-primary-red);\n}\n\n.raffle-details {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.raffle-item {\n  display: flex;\n  align-items: flex-start;\n  color: #3B3B3B;\n}\n\n.raffle-item:last-child {\n  margin-bottom: 0;\n}\n\n.icon {\n  width: 24px;\n  height: 24px;\n  margin-right: 10px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  flex-shrink: 0;\n}\n\n.icon-calendar {\n  background-image: url('/public/images/calendar.svg');\n}\n\n.icon-extraction {\n  background-image: url('/public/images/user-scan.svg');\n}\n\n.icon-verification {\n  background-image: url('/public/images/reports.svg');\n}\n\n.icon-winners {\n  background-image: url('/public/images/trophy.svg');\n}\n\n.item-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.label {\n  font-family: var(--font-headline-1);\n  font-weight: 600;\n  font-size: 12px;\n  color: var(--shell-light-text);\n  margin-bottom: 2px;\n}\n\n.value {\n  font-family: var(--font-headline-2);\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 140%;\n}\n\n/* Paginação para dispositivos móveis */\n.calendar-pagination {\n  display: none; /* Oculto por padrão em desktop */\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  gap: 10px;\n  position: relative;\n  z-index: 20;\n}\n\n.pagination-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: var(--color-contrast-gray);\n  border: none;\n  cursor: pointer;\n  transition: width ease-in 0.3s, height ease-in 0.3s, background-color ease-in 0.3s;\n}\n\n.pagination-dot.active {\n  width: 8px;\n  height: 8px;\n  background-color: var(--color-primary-red);\n}\n\n/* Responsividade */\n@media (max-width: 1230px) {\n  /* Ajuste para telas menores que 1230px */\n  .calendar-viewport {\n    width: calc(280px * 3 + 20px * 2); /* Mantém a largura para 3 cards */\n  }\n}\n\n@media (max-width: 768px) {\n  .integrated-container {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .scratchcard-section {\n    margin-right: 0;\n    margin-bottom: 30px;\n  }\n\n  .calendar-container {\n    width: fit-content;\n    padding: 20px 24px;\n    margin: 0 auto;\n  }\n\n  .calendar-slider {\n    padding: 0;\n  }\n  \n  .calendar-section {\n    padding-left: 0;\n    width: 100%;\n  }\n\n  .calendar-navigation {\n    width: 100%;\n    transform: translateY(-10px);\n  }\n\n  .calendar-navigation .nav-button-item {\n    position: absolute;\n  }\n\n  .calendar-navigation .prev {\n    left: 0;\n  }\n\n  .calendar-navigation .next {\n    right: 0;\n  }\n  \n  /* Mostra a paginação em dispositivos móveis */\n  .calendar-pagination {\n    display: flex;\n  }\n  \n  /* Ajusta o viewport para mostrar apenas 1 card por vez em dispositivos móveis */\n  .calendar-viewport {\n    width: 300px;\n  }\n  \n  .raffle-card {\n    width: 280px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
